import { differenceInDays } from 'date-fns';
import { tierThemes } from 'features/premium/benefits';
import { Tier } from 'features/premium/entities';
export const getRequiredTier = (connectionsLimitMap, requiredConnections) => {
    if (connectionsLimitMap) {
        if (connectionsLimitMap.FREE !== null && requiredConnections > connectionsLimitMap.FREE) {
            if (connectionsLimitMap.PLUS !== null && requiredConnections > connectionsLimitMap.PLUS) {
                if (connectionsLimitMap.PRO !== null && requiredConnections > connectionsLimitMap.PRO) {
                    return Tier.ultimate;
                }
                return Tier.pro;
            }
            return Tier.plus;
        }
    }
    return Tier.free;
};
export const isConnectionWithConsentExpiresAt = (connection) => !!connection.consentExpiresAt;
export const isConnectionExpiring = (connection) => !connection.isClosed &&
    (connection.needsReconsent ||
        (connection.consentExpiresAt && differenceInDays(new Date(connection.consentExpiresAt), new Date()) <= 10));
export const isConnectionBroken = (connection) => !!connection.needsReauth || !!connection.needsReconsent;
export const canRenewConnection = (connection) => Boolean(connection.needsReauth ||
    connection.needsReconsent ||
    connection.consentExpiresAt ||
    connection.bankInfo.canRenewAccess ||
    connection.bankInfo.provider === 'PLAID');
export const isBankAccountBroken = (account) => !!account.needsReauth || !!account.needsReconsent || (!account.isClosed && !!account.isRemoved);
/**
 * @param connections - connections that are sorted (mutated).
 * @returns Sorted connections. Earliest expiry first.
 */
export const sortConnectionsByExpiresAt = (connections) => connections.sort((a, b) => {
    if (!a.consentExpiresAt)
        return 1;
    if (!b.consentExpiresAt)
        return -1;
    return new Date(a.consentExpiresAt).getTime() - new Date(b.consentExpiresAt).getTime();
});
export const sortedConnectionsByExpiresAt = (connections) => sortConnectionsByExpiresAt([...connections]);
export const statusStrings = {
    statusWorking: 'Working',
    statusNeedsFix: 'Requires action',
    statusDegraded: 'Performance degraded',
    statusDown: 'Unavailable',
    statusSyncing: 'Syncing',
    statusNotSyncing: 'Not syncing',
};
const getTierText = (connectionsLimitMap, tier) => {
    if (!connectionsLimitMap)
        return null;
    return connectionsLimitMap[tier] === null ? 'unlimited' : connectionsLimitMap[tier];
};
export const allowedConnectionsInfo = (connectionsLimitMap) => `Emma allows you to have ${getTierText(connectionsLimitMap, Tier.free)} bank connections on the ${tierThemes.FREE.shortName} plan, ${getTierText(connectionsLimitMap, Tier.plus)} on ${tierThemes.PLUS.name} and ${getTierText(connectionsLimitMap, Tier.pro)} on ${tierThemes.PRO.shortName} and ${tierThemes.ULTIMATE.shortName}.`;
